import { useQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseQuery } from '@/lib/apollo/types'

import type { QueryVars, SubjectsBySearchResponse } from './query'
import GET_SUBJECTS_BY_SEARCH from './query'

export const useGetSubjectsBySearch: WrappedUseQuery<
  SubjectsBySearchResponse,
  QueryVars
> = options =>
  useQuery<SubjectsBySearchResponse, QueryVars>(GET_SUBJECTS_BY_SEARCH, {
    ...options,
    client: agentClient,
  })
